module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/step2-8fb54a06e3da2dcab0efac49764402aa.png";